import { createSelector } from 'reselect';
import { Map as ImmutableMap } from 'immutable';
const getPlatformFlowsApplicationRoot = state => state.platformFlowsApplication;
export const getFlowEnableErrors = createSelector([getPlatformFlowsApplicationRoot], root => root.flowEnableErrors);
export const getTestFlowFlowId = createSelector([getPlatformFlowsApplicationRoot], root => root.testFlow.flowId);
export const getTestFlowObjectId = createSelector([getPlatformFlowsApplicationRoot], root => root.testFlow.objectId);
export const getTestFlowOptions = createSelector([getPlatformFlowsApplicationRoot], root => root.testFlow.options);
export const getHighlightedActionIds = createSelector([getPlatformFlowsApplicationRoot], root => root.highlightedActionIds);
export const getIsCanvasVirtualRenderingDisabled = createSelector([getPlatformFlowsApplicationRoot], root => root.isCanvasVirtualRenderingDisabled);
export const getBulkProcessingRootByFlowId = flowId => state => {
  const root = getPlatformFlowsApplicationRoot(state);
  return root.bulkProcessingStatusByFlowId.get(flowId) || ImmutableMap();
};
export const getActionIsBulkProcessing = (flowId, actionId) => state => {
  const bulkProcessingRoot = getBulkProcessingRootByFlowId(flowId)(state);
  const actionsBulkProcessing = bulkProcessingRoot.get('actionsBulkProcessing');
  return actionsBulkProcessing && actionsBulkProcessing.has(actionId);
};
export const getEnrollmentIsBulkProcessing = flowId => state => {
  const bulkProcessingRoot = getBulkProcessingRootByFlowId(flowId)(state);
  return !!bulkProcessingRoot.get('enrollmentIsBulkProcessing');
};
export const getShouldPollBulkProcessing = flowId => state => {
  const bulkProcessingRoot = getBulkProcessingRootByFlowId(flowId)(state);
  return !!bulkProcessingRoot.get('shouldPollBulkProcessing');
};
export const getIsResolutionPanelOpen = state => state.platformFlowsApplication.isResolutionPanelOpen;
export const getIsInResolutionMode = state => state.platformFlowsApplication.isInResolutionMode;